export default "__VITE_PUBLIC_ASSET__0964a276__"